var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"component"},[_c('div',{staticClass:"sliderImage"},[_c('img',{attrs:{"src":_vm.image.path}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }